import { heroIcons } from './HeroIcons'
import { sparkIcons } from './SparkAi'

export const LibraryIcons = { ...sparkIcons, ...heroIcons }
